<template>
   <div id="form-gradient">
      <div id="cartoon-bg">
         <div
            id="select-more-form"
            :class="containerClass"
            class="d-flex flex-column flex-nowrap">
            <div
               class="headline"
               :class="breakpoint"
               v-text="$store.getters.headline" />
            <div
               class="mx-auto"
               style="max-width: 500px; position: relative">
               <div class="skilt" />
               <products-grid
                  :limit="4"
                  :intro="true" />
               <submit-products-button wrapper="#select-more-form" />
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductsGrid from '../ProductsGrid';
import SubmitProductsButton from '../SubmitProductsButton';

export default {
   name: 'SelectMoreForm',
   components: {
      SubmitProductsButton,
      ProductsGrid,
   },
   computed: {
      ...mapGetters(['containerClass']),
   },
};
</script>

<style lang="scss" scoped>
.headline {
   //font-family: 'Lato', sans-serif;
   //font-style: italic;
   font-size: 200%;
   margin: 1.5em auto 2.5em auto;
   text-align: center;

   &.sm,
   &.xs {
      font-size: 160%;
   }
}

.skilt {
   background-size: contain !important;
   height: 39px;
   top: -25px;
   position: absolute;
   width: 124px;
   z-index: 500;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.png) no-repeat left top
      transparent;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.svg) no-repeat left top
      transparent;
}
#form-gradient {
   background: linear-gradient(
      to bottom,
      rgba(203, 220, 226, 0.1) 0%,
      rgba(188, 215, 226, 0.4) 68%,
      rgba(138, 200, 226, 0.6) 90%
   );
}
#cartoon-bg {
   background-image: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/landskab_ekstra_bakker.png),
      linear-gradient(180deg, rgba(203, 220, 226, 0.6) 0, rgba(188, 215, 226, 0.6) 82%, rgba(138, 200, 226, 0.6));
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#99cbdce2",endColorstr="#998ac8e2",GradientType=0);
   background-repeat: repeat-x;
   background-position: bottom;
   box-shadow: inset 0 5px 15px rgb(0 0 0 / 15%);
   padding-bottom: 85px;
   //margin-bottom: 50px;
   //padding-top: 75px;
   font-style: normal;
   user-select: none;
   min-height: calc(100vh - 110px);
}
</style>
